export const FETCH_BORROWERS_PROSPECTS_LOADING = 'FETCH_BORROWERS_PROSPECTS_LOADING';
export const FETCH_BORROWERS_PROSPECTS_SUCCESS = 'FETCH_BORROWERS_PROSPECTS_SUCCESS';
export const FETCH_BORROWERS_PROSPECTS_ERROR = 'FETCH_BORROWERS_PROSPECTS_ERROR';
export const FETCH_BORROWERS_ACTIVE_LOADING = 'FETCH_BORROWERS_ACTIVE_LOADING';
export const FETCH_BORROWERS_ACTIVE_SUCCESS = 'FETCH_BORROWERS_ACTIVE_SUCCESS';
export const FETCH_BORROWERS_ACTIVE_ERROR = 'FETCH_BORROWERS_ACTIVE_ERROR';

export const SELECT_BORROWER = 'SELECT_BORROWER';
export const REMOVE_SELECTED_BORROWER = 'REMOVE_SELECTED_BORROWER';
